<template>
  <div :class="['top-menu',siteIsMain ? '' : 'nonemain-mode']">
    <div class="top-menu__intersector" ref="intersector"></div>

	<!-- New Top Strip ****************** -->
	<div :class="['px-2xl','top-strip',
		siteIsMain ? '' : 'nonemain-mode',siteSelectorOpen ? 'expended':'']" >

		<!-- CLOSED STRIP ROW -->
		<div>
			<!-- THIS IS THE DESKTOP MENU -->
			<!-- SHOW LOGO ONLY ON NONE-MAIN SITES -->
			<a v-if="siteIsMain===false" 
				:href="'https://www.mis-implants.com/loc/'+localeString" 
				class="logo-small-link"><logo :fill="'#ffffff'" /></a> 	
			
			<!-- DESKTOP MENU -->
			<template v-if="$device.mobile==false">
				<!-- MAIN SITE LINK -->
				<a v-if="siteIsMain==false" :class="['link1',siteIsMain==false ? '' : 'act']" 
					:href="'https://www.mis-implants.com/loc/'+localeString" >
					{{localize(`${strip_link1}`)}}
				</a>							
				<router-link v-if="siteIsMain==true" :class="['link1',siteIsMain==true ? 'act' : '']"  :to="`${parsedLocaleString}/`" v-text="localize(`${strip_link1}`)"></router-link>

				<span>|</span> 
				<!-- LAB LINK-->
				<a v-if="!siteIsLab" :class="[!siteIsLab ? '' : 'act']"  
					:href="'https://lab.mis-implants.com/loc/'+localeString">{{localize(`${strip_link2}`)}}</a>
				<router-link v-if="siteIsLab" :class="[siteIsLab ? 'act' : '']"  :to="`${parsedLocaleString}/`" v-text="localize(`${strip_link2}`)"></router-link>

				<span>|</span>
				<!-- PATIENT -->
				<a v-if="!siteIsPatient" :class="[!siteIsPatient ? '' : 'act']" 
					 :href="'https://patient.mis-implants.com/loc/'+localeString" >{{localize(`${strip_link3}`)}}</a>
				<router-link v-if="siteIsPatient" :class="[,siteIsPatient ? 'act' : '']"  :to="`${parsedLocaleString}/`" v-text="localize(`${strip_link3}`)"></router-link>
			</template>

			<template v-if="$device.mobile">
				<!-- MOBILE MODE -->		
				<a @click="openSiteSelector()" :class="['link1','act']" >
					{{currentSiteTitle}} 
					<i style="padding-left:4px;top:3px" class="fal fa-angle-down"></i></a>								
			</template>
		</div>
		<div class="top-strip-selector">
			<!-- EXPENDED MENU -->
			<ul>
				<li v-if="!siteIsMain">
					<a :href="'https://www.mis-implants.com/loc/'+localeString" >{{localize(`${strip_link1}`)}}</a></li>
				<li v-if="!siteIsLab">
					<a :href="'https://lab.mis-implants.com/loc/'+localeString" >{{localize(`${strip_link2}`)}}</a></li>
				<li v-if="!siteIsPatient">
					<a :href="'https://patient.mis-implants.com/loc/'+localeString" >{{localize(`${strip_link3}`)}}</a></li>
			</ul>
		</div>
		
		<!--
        <a  v-if="isPatientPage()" style="float:right;" href="#p" @click.prevent="$emit('region-selector-tapped')" :class="regionClass">
		  <i class="fal fa-globe"></i>
        </a>
		-->

		<!-- //////////////////////////////// regin selector //////////////////////////////// -->
		<!-- //////////////////////////////// regin selector //////////////////////////////// -->
		<div class="top-strip-right" id="reg_select" @click.prevent="$emit('region-selector-tapped')">			
			
			<a v-if="siteIsLab" @click.stop="" target="_blank" style="top:4px;padding-right:15px;" href="https://www.mis-implants.com/company/contact-us">
				<i class="fal fa-envelope"></i>
			</a>

			<!-- DISPLAY GLOBE -->
			<i style="top:3px" v-if="locale=='en'" class="fal fa-globe"></i>			
			<!-- DISPLAY FLAG IF NOT GLOBAL SITE -->
			<img class="flag" v-if="locale!='en'" 
			style="width:20px;height:auto;position:relative;top:4px;" :src="flagURL">			
			<!-- DISPLAY NAME (SHORT IF MOBILE) -->
			<span class="localName" v-if="locale!='EN'" 
				style="padding-left:8px;font-weight:400;padding-right:3px;">				
				<template v-if="$device.mobile">
					{{locale.substring(locale.length-2)}}
				</template>
				<template v-if="!$device.mobile">
					<span v-text="languageName"></span>
				</template>
			</span>
			<i style="padding-left:4px;top:3px" class="fal fa-angle-down localeArrow"></i>
		</div>
		<!-- //////////////////////////////// regin selector //////////////////////////////// -->
		<!-- //////////////////////////////// regin selector //////////////////////////////// -->
		<!--<img v-else :src="`/img/flags/${locale.cc}.svg`" />-->
	</div>

	<!-- MAIN SITE MENU -->
    <div v-if="siteIsMain" :class="['top-menu--content','px-2xl',menuMode ? `mode-${menuMode}` : '']">
      <!-- !!overlay.active ? 'menu-active' : '' -->
      <div class="top-menu--content__left">
        <router-link :to="`${parsedLocaleString}/`" class="root-link">
          <logo :fill="menuMode === 'hero' ? '#ffffff' : '#0068AA'" />
        </router-link>
        <router-link				  
          v-for="item in menuItems"
          :class="['menu-link',isPatientPage() ? 'hidden' : '']"
          :key="item.cid"
          :to="item.path"
          v-text="item.title"
        />
      </div>
	
      <div class="top-menu--content__right">
		  <!-- Add to list -->
        <a class="viewCollections" :title="localize('View List')" @click="showCollections()">
			<i class="fal fa-list-alt"></i>
			<span v-if="collectedItemsCount>0" class="cir"></span>
		</a>
          
        <a 
          href="#p"
          :class="[
            overlay.active && overlay.type === 'search'
              ? 'router-link-exact-active'
              : ''
          ]"
          @click.prevent="toggleOverlay({ active: true, type: 'search' })"
          ><i class="fal fa-search"></i
        ></a>
        <router-link :to="`${parsedLocaleString}/company/contact-us`"
			v-if="$route.path.toLowerCase() != '/patient'"><i class="fal fa-envelope"></i></router-link>

		<!--
        <a id="reg_select"
          href="#p"
          @click.prevent="$emit('region-selector-tapped')"
          :class="regionClass"
        >
          <i v-if="locale.cc === ''" class="fal fa-globe"></i>
          <img v-else :src="`/img/flags/${locale.cc}.svg`" />
        </a>
		-->

        <span v-if="$route.path.toLowerCase() != '/patient'"
          :class="[
            'hamburger',
            overlay.active && overlay.type === 'overlay-menu' ? 'active' : ''
          ]"
          @click="toggleOverlay({ active: true, type: 'overlay-menu' })"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { subdomain } from "@/utils";
export default {
  props: {
    strip_link1: {
      type: String,
      default: "Dental Professionals"//v-text="localize('Sitemap')"
    },
    strip_link2: {
      type: String,
      default: "Lab Technicians"
    },
    strip_link3: {
      type: String,
      default: "Patients"
    },

    // localeString: {
    //   type: String,
    //   default: ""
    // },
    mode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      observer: null,
      prevRatio: null,
      menuMode: "",
	  sitename: "",
	  siteIsLab: false,
	  siteIsPatient: false,
	  siteIsMain: true,	  
	  siteSelectorOpen:false
    };
  },
  watch: {
    mode() {
      console.log("mode changed.. ", this.mode);
      this.checkMode();
    }
  },
  detroyed() {
    this.destroyObserver();
  },
  created() 
  {
	var vm=this;
	vm.setSitesMenu();
    this.checkMode();
	this.readCollections();
  },
  computed: {
    ...mapState(["overlay", "menuItems", "locale","collections","collections", "auid"]),
    ...mapGetters(["localeString"]),
	currentSiteTitle()
	{
		if(this.siteIsLab){
			return this.localize(this.strip_link2);
		}
		else if(this.siteIsPatient){
			return this.localize(this.strip_link3);
		}else{
			return this.localize(this.strip_link1);
		}
	},
    collectedItemsCount() {
		return this.collections.activeCollectionItems.length;
      //return this.collections.children.length;
    },
    regionClass() {
      return this.locale.cc === "" ? "" : "has-cc";
    },
    localePath() {
      return this.locale.cc === "us" ? "en-us" : "";
    },
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    locale() {
      return this.$route.params.locale || this.$defaultLang;
    },
	flagURL()
	{
		var lang = this.locale.substring(this.locale.length-2);
		return "/img/flags/"+lang+".svg";
	},
	languageName()
	{
		//on mobile version return short name:		
		//if($device.mobile)
		//{
			//{{locale.substring(locale.length-2)}}
			//return this.locale.substring(this.locale.length-2)
		//}		
		//todo:
		//get the name by the APP_CONFIG.APP_REGIONS LIST OF REGIONS
		//alert("currentLocale="+currentLocale);

		var name = 'GLOBAL';
		var currentLocale = this.$route.params.locale || this.$defaultLang;
		if(currentLocale!="en")
		{
			//NONE-GLOBAL LANGAUGES, GET THE LANGUAGE NAME BY THE LOCALE STRING VALUE (eg:IT-IT)
			let localeItem = _.filter(APP_CONFIG.APP_REGIONS, function(o){ 
				return o.locale == currentLocale; 
			});
			if(localeItem && localeItem.length>0){				
				name = localeItem[0].name;
				console.log("TopMenu localeItem name => "+localeItem[0].name);
			}
		}
		/*
		if(currentLocale=='en-us'){name="USA"}
		if(currentLocale=='es-es'){name="Español"}
		if(currentLocale=='fr-fr'){name="Français"}
		if(currentLocale=='de-de'){name="Deutsche"}
		if(currentLocale=='tr-tr'){name="Türkçe"}
		if(currentLocale=='it-it'){name="Italiano"}
		*/
		return name;
	}
  },
  methods: {
	setSitesMenu()
	{
	  	//DEFINE THE CURRENT SITE
		//this.sitename = subdomain();//.toLowerCase();
		//this.currentSiteTitle = "";
		//this.currentSiteTitle = this.localize(this.strip_link1);

		this.siteIsMain = true;
		this.siteIsLab  = this.isLabPage();
		this.siteIsPatient  = this.isPatientPage();	
		if(this.siteIsLab){
			//this.currentSiteTitle = this.localize(this.strip_link2);
			this.siteIsMain=false;
		}
		if(this.siteIsPatient){
			//this.currentSiteTitle = this.localize(this.strip_link3);
			this.siteIsMain=false;
		}

	},
	openSiteSelector()
	{
		this.siteSelectorOpen=!this.siteSelectorOpen;
	},
	readCollections()
	{
		var vm=this;
		var apiURL = "https://api.mis-implants.com/api/collections?AUID="+vm.auid;
		fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
		.then(function(response){return response.json();})
		.then(function(response){
			vm.setCollectionsList(response);//update the list
		});         
	},
	showCollections()
	{
		this.showCollectionsViewer();
	},
	getLangName()
	{
		var name = 'GLOBAL';//this.locale;
		//on mobile version return short name:		
		if(this.locale=='en-us'){name="USA"}
		if(this.locale=='es-es'){name="Español"}
		if(this.locale=='fr-fr'){name="Français"}
		if(this.locale=='de-de'){name="Deutsch"}
		if(this.locale=='tr-tr'){name="Türkçe"}
		if(this.locale=='it-it'){name="Italiano"}
		//
		return name;
	},
    isPatientPage() {
	  	var routePart = this.$route.path.toLowerCase().indexOf('/patient');
        var __subdomain = subdomain();
  		  //in case of /Patient or de-de/Patient
      	return routePart ===0 || routePart === 6 || __subdomain === 'patient'
    },
    isLabPage() {
	  	var routePart = this.$route.path.toLowerCase().indexOf('/lab');
        var __subdomain = subdomain();
  		  //in case of /Patient or de-de/lab
      	return routePart ===0 || routePart === 6 || __subdomain === 'lab'
    },
    ...mapActions(["toggleOverlay","showCollectionsViewer","setCollectionsList"]),
    checkMode() {
      let mode = this.mode;
      this.menuMode = mode;
      if (mode === "hero") {
        this.createObserver();
      } else {
        this.destroyObserver();
      }
    },
    createObserver() {
      // console.log("create observer...");
      this.$nextTick(function() {
        let el = this.$refs.intersector,
          options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.8
          };
        if (window.IntersectionObserver && !this.observer) {
          this.observer = new IntersectionObserver(
            this.handleIntersect,
            options
          );
        }
        this.observer.observe(el);
      });
    },
    destroyObserver() {
      if (this.observer) {
        let el = this.$refs.intersector;
        this.observer.unobserve(el);
      }
    },
    handleIntersect(entries) {
      let vm = this;
      entries.forEach(function(entry) {
        if (entry.intersectionRatio > vm.prevRatio) {
          vm.menuMode = "hero";
        } else {
          vm.menuMode = "";
        }
        vm.toggleOverlay(false);
        vm.prevRatio = entry.intersectionRatio;
      });
    }
  }
};
</script>

<style scoped>
	.viewCollections{
		position: relative;
	}
	.viewCollections .cir
	{
		position: absolute;
		background-color:#249ff0;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		top: -6px;
		left: -3px;
	}
	.top-strip
	{
		transition: cubic-bezier(0.075, 0.82, 0.165, 1) all 0.2s;
		overflow-y: hidden;
	}
	.top-strip.expended
	{
		height:150px;
	}
	.top-strip-selector
	{
		clear:both;
	}
	.top-strip-selector ul
	{
		list-style-type: none;
		padding-left: 61px;
		padding-top: 8px;
	}
	.top-strip-selector ul li
	{
		clear: both;
		padding: 10px 0px;
	}





</style>


<style lang="stylus">
mobile-break = 1024px
/*
	Hamburger Menu Styling (icon modes)
*/
.hamburger
	width 24px
	height 16px
	color #2e2e2e
	border-top 2px solid rgba(#f1f1f1, 0.7)
	border-bottom 2px solid rgba(#f1f1f1, 0.7)
	position relative
	cursor pointer
	border-radius 0px
	user-select none
	transition width 0.25s ease-out, border-radius 0.25s ease-out, margin-right 0.25s ease-out, color 0.25s ease, border-color 0.25s ease
	z-index 11
	&:after
	&:before
		content ''
		width 100%
		position absolute
		top 50%
		left 0
		transform translate(0,-50%)
		height 2px
		background rgba(#f1f1f1, 0.5)
		transition width 0.25s ease-out-back, background-color 0.25s ease-out, transform 0.25s ease-out, left 0.25s ease-out
	+desktop()
		&:hover
			border-color rgba(#f1f1f1, 0.7)
			&:after
				background rgba(#f1f1f1, 0.7)
	&.active
		border 0
		width 52px
		height 52px
		transform translateX(25%)
		&:after
			background-color rgba(#f1f1f1, 0.9)
			left 50%
			transform translate(-50%,-50%) rotate(45deg)
		&:before
			background-color rgba(#f1f1f1, 0.9)
			left 50%
			transform translate(-50%,-50%) rotate(-45deg)
		+desktop()
			&:hover
				border-color rgba(#f1f1f1, 0.9)
				&:after
				&:before
					// transition width 400ms ease-out-back, background-color 400ms ease
					background rgba(#f1f1f1, 0.9)
					width 105%


/*
	Top Menu Styling
*/

.top-strip
	background-color #0b3454;
	clear both
	width 100%
	color #fff
	position fixed
	z-index 1002
	height 40px
	padding-top 8px
	padding-bottom 8px	
	font-size 14px
	a
		color #fff !important
		letter-spacing 0px !important
		position relative 
		top 3px
	span
		padding 8px
		position relative 
		top 2px
	.logo-small-link
		display inline-block !important				
		position fixed
		top 7px
		margin 0px
		//display none
		padding-right 12px		
		img
		svg
			min-width 0px
			height 19px
		+below(815px)			
			height 10px !important
	.logo-hidden
		display none
	.localName
		text-transform uppercase
		+below(815px)			
			display none
	.localeArrow
		+below(815px)			
			display none


.top-strip-right
	cursor pointer
	background-color none
	position absolute
	top 0px
	right 0px
	height 40px
	padding-left 24px
	padding-right 24px
	font-size 14px
	padding-top 8px
	padding-bottom 8px	
	+below(815px)
		padding-left 12px
		padding-right: 8.5vw;
	i
		position relative 
	span
		font-weight 700
	//&:hover
	//	background-color #159df3



.top-menu
	position absolute
	top 0
	width 100%
	z-index 1001
	height 90px
	+below(815px)
		height 60px
	&__intersector
		height 85vh
		position absolute
		width 100%
		pointer-events none
	&--content
		position fixed
		display flex
		width 100%
		height 90px
		background rgba(#fff,0)
		justify-content space-between
		align-items center
		transition background 0.3s ease-out
		top 33px
		&:not(.mode-hero)
			border-bottom 1px solid gray_2
		+below(815px)
			height 60px
		a
			color rgba(#fff, 0.98)
			font-size 14px
			transition color 0.3s ease-out
			text-transform uppercase
			// MIS LOGO LINK
			&.root-link
				max-width 110px
				display inline-block
				img
				svg
					max-width 100%
				// +below(1024px)
				// 	max-width 80px
				+below(mobile-break)
					max-width 15vmin //dubi
			&.menu-link
				color gray_8
				position relative
				font-size responsive 12px 16px
				font-weight 300 !important
				transform translateY(-25%)
				white-space nowrap
				&:after
					content ''
					position absolute
					left 50%
					transform translateX(-50%)
					bottom -3px
					height 1px
					width 0%
					background #fff
					transition 0.2s width ease-out-expo
				+below(mobile-break)
					display none
			// &:hover
			// 	color rgba(#fff, 1)
			&.hidden
				display none
		&__left
		&__right
			display flex
			align-items baseline
			justify-content flex-start
			.has-cc
				position relative
				width 20px
				height @width
				border-radius 10px
				overflow hidden
				filter saturate(0.6)
				border 1px solid rgba(gray_8, 0.55)
				transition filter 0.3s ease-out,border 0.3s ease-out
				backface-visibility hidden
				transform translate3d(0,0,0)
				img
					center()
					min-width 170%
					min-height @min-width
					max-width 190%
					max-height @max-width
				+desktop()
					&:hover
						filter saturate(0.8)
						border 1px solid blue_4



			a
			a:visited
				color gray_8
				margin-right 15px
				transition color 0.3s ease-out
				backface-visibility hidden
				&:active
				&:focus
					outline 0
				.fa-envelope
					transform scale(1.11)
				/.mode-hero &
					color #fff
				/.mode-hero &
					fill #fff
					will-change fill
					transition fill 0.3s ease-out
				// &.router-link-active
				// 	color blue_5
				+desktop()
					&:hover
						color blue_5
						/.mode-hero &
							color #fff
							&:after
								width 100%
				&:first-child
					margin-right 30px
					+below(1024px)
						margin-right 15px
		&__left
			a.router-link-active
			a.router-link-active:visited
				color blue_5
		&__right
			justify-content flex-end
			align-items center
			a
				margin-right 0
				margin-left 15px
				font-size 18px
				transition color 0.3s ease-out, transform 0.3s ease-out, zoom 0.3s ease-out
				backface-visibility hidden
				-webkit-font-smoothing subpixel-antialias
				transform translate3d(0, 0, 0)
				transform-origin center
				&.router-link-exact-active
					color blue_5
				*
					backface-visibility hidden
					-webkit-font-smoothing subpixel-antialias
					transform translateZ(0)
				+desktop()
					&:hover
						color blue_5 !important
				&:first-child
					margin-right 0
			.hamburger
				margin-left 15px
		&:not(.menu-active):not(.mode-hero)
			background rgba(#fff,1)
			border-bottom 1px solid rgba(gray_8, 0.3)

				// &:hover
				// 	color lighten(gray_8, 45)
			.hamburger
				border-color lighten(gray_8, 30)
				&:after
				&:before
					background-color lighten(gray_8, 30)


.menu-active .top-menu
	pointer-events none
	.hamburger
		pointer-events all
	a
		display none


.link1
	//font-weight 500 !important

.nonemain-mode
	height 40px;
	.logo-small-link		
		display inline-block !important
	.link1
		padding-left 60px
		//font-weight 100 !important
	&.act
		//border-bottom solid 2px red
	.top-menu--content
		display none

.act
	font-weight 500 !important

</style>

